import React from 'react';
import AnswerOption from './AnswerOption';

class MultipleOptionQuestion extends React.Component {
  constructor(){
    super();
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler(field, value, otherValue, isError, errors){
    this.props.handleChangeListener(field, value, otherValue, isError, errors);
  }

  generateOptions = (field, options, predefinedValues) => {
    return options.map((option, key) => {
      const {value, text} = option;
      if(value === predefinedValues){
        return <AnswerOption
                field={field}
                value={value}
                text={text}
                onChangeHandler={this.onChangeHandler}
                keyIdentifier={key}
                key={key}
                isChecked={true}
              />
      }
      return <AnswerOption
                field={field}
                value={value}
                text={text}
                onChangeHandler={this.onChangeHandler}
                keyIdentifier={key}
                key={key}
              />
    });
  }

  render() {
    const {field,text,note,predefinedValue, errors, isError} = this.props;
    const errorList = errors !== null? errors.map( (error) =>  <li key={error}>{error}</li>) : null
    const options = this.generateOptions(field, this.props.options, predefinedValue);

    return (
        <div className="multiple-option-question">
            <div className="form-group">
                <label htmlFor={field}>{text}</label>
                <div className="form-check">
                {
                  options
                }
                </div>
                <p className="question-subinstruction">{note}</p>
                {isError === true ? 
                <ul className="error">
                  {errorList}
                </ul>
                : null
                } 
            </div>
        </div>
    ); 
  }
}

export default MultipleOptionQuestion;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/QuestionsTypes/MultipleOptionQuestion.js